import React,{Component} from 'react';
import {CanvasJSReact} from '../assets/canvasjs.react';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
class Quiz_Report_Tmp extends React.Component{
    render() {
		const options = {
			exportEnabled: true,
			animationEnabled: true,
			title: {
				text: "Result"
			},
			data: [{
				type: "pie",
				startAngle: 75,
				toolTipContent: "<b>{label}</b>: {y}%",
				showInLegend: "true",
				legendText: "{label}",
				indexLabelFontSize: 16,
				indexLabel: "{label} - {y}%",
				dataPoints: [
					{ y: 49, label: "Correct" },
					{ y: 9, label: "Wrong" },
					{ y: 5, label: "Not Attemped" }
					
				]
			}]
		}
		
		return (
		<div>
			<CanvasJSChart options = {options} 
				/* onRef={ref => this.chart = ref} */
			/>
			{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
		</div>
		);
        }
}
export default Quiz_Report_Tmp